import { FC } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import Icon from "../../../ui/global/Icon";
import Colors from "../../../ui/global/Colors";

const PlayPauseOverlayContainer = styled(motion.div)`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    z-index: 2;
    pointer-events: auto;
    
    & > * {
        color: ${Colors.white};
    }
`;

interface PlayPauseOverlayProps {
    overlayIcon: "play" | "pause";
    showOverlay: boolean;
    onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const PlayPauseOverlay: FC<PlayPauseOverlayProps> = ({ overlayIcon, showOverlay, onClick }) => {
    return (
        <AnimatePresence>
            {showOverlay && (
                <PlayPauseOverlayContainer
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.8 }}
                    transition={{ duration: 0.4 }}
                    onClick={onClick}
                >
                    <Icon icon={overlayIcon} size={36} color="white"/>
                </PlayPauseOverlayContainer>
            )}
        </AnimatePresence>
    );
};

export default PlayPauseOverlay;